module.exports = __webpack_public_path__ + "img/austria-eye-and-ear-diseases-female.91c7d0f1.png";